/**
 * 受け取った時間（ミリ秒）がどれくらい前か計算し
 * 対応する文字列を返す
 *
 * @param time_ms
 * @param translations
 * @return {string}
 */
export const howLongAgo = (time_ms, translations = {}) => {
    const passedHours = (Date.now() - time_ms) / (1000 * 60 * 60);

    const today = translations.today || 'Today';
    const x_days_ago = translations.x_days_ago || '{day} days ago';

    if (passedHours <= 24) {
        return today;
    } else if (passedHours <= 24 * 30) {
        const passedDays = Math.ceil(passedHours / 24);
        return x_days_ago.replace('{day}', passedDays);
    } else {
        return x_days_ago.replace('{day}', "30+");
    }
};
